<template>
  <DBox
    :id="'cmp-distribution-shop_grouops-sidewindow-contracts'"
    :addButton="false"
    :addLinkLabel="$t('contracts')"
  >
    <NTable
      class="dbox1"
      id="distribution-shop_grouops-sidewindow-contracts-list"
      :config="tableConfig"
      :headers="headers"
      :items="selectedShop_groupDetails.related_contracts || []"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('royalty_account')">
            <span
              @click.stop="(e) => onSelectRoyaltyAccount(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['royalty_account']"
            >
              {{ item["royalty_account"] }}
            </span>
          </td>
          <!-- <td v-bind="tdcon('id')">
            <span class="txtov" :title="item['sage_id']">
              {{ item["sage_id"] }}
            </span>
          </td>
          <td v-bind="tdcon('id_prod')">
            <span class="txtov" :title="item['id_prod']">
              {{ item["id_prod"] }}
            </span>
          </td> -->
          <td v-bind="tdcon('shop_contract_ref')">
            <span
              @click.stop="(e) => onSelectRoyaltyContract(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['contract_ref']"
            >
              {{ item["contract_ref"] }}
            </span>
          </td>
          <td v-bind="tdcon('contract')">
            <div
              class="ut-colcen"
              style="align-items: flex-start"
              :title="item['contract_name']"
              @click.stop="(e) => onSelectRoyaltyContract(item)"
            >
              <span class="txtov ut-link ut-text-accent5">
                {{ contractFirstName(item) }}
              </span>
              <span class="txtov ut-link ut-text-accent5">
                {{ contractLastName(item) }}
              </span>
            </div>
          </td>
          <td v-bind="tdcon('channel')">
            <span class="txtov" :title="item['channel']">
              {{ item["channel"] }}
            </span>
          </td>
          <td v-bind="tdcon('ds_info')">
            <span class="txtov" :title="item['info']">
              {{ item["info"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import {
  royaltyAccountsListLDTRoutes,
  royaltyContractsListLDTRoutes,
} from "../../../royalty/router/routes";

export default {
  components: {
    DBox,
    NTable,
  },
  props: ["selectedShop_groupDetails"],
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        rowHeight: 32,
        headerHeight: 32,
      });
    },
    headers: function () {
      return [
        createTableHeader("royalty_account", { mw: 200 }),
        // createTableHeader("id"),
        // createTableHeader("id_prod", { f: 0.5 }),
        createTableHeader("shop_contract_ref", { mw: 100 }),
        createTableHeader("contract", { mw: 200 }),
        createTableHeader("channel", { mw: 100 }),
        createTableHeader("ds_info"),
      ];
    },
    contract_id: function () {
      return this.$route.params.contract_id;
    },
  },
  methods: {
    onSelectRoyaltyAccount: function (selectedItem) {
      console.log("onSelectContract ", selectedItem);
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: selectedItem.royalty_account_id,
          tab: "overview",
        },
      });
      // this.$emit("selected", selectedContract.royalty_account_id);
    },
    onSelectRoyaltyContract: function (selectedItem) {
      console.log("onSelectContract ", selectedItem);
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: selectedItem.contract_id,
          tab: "overview",
        },
      });
    },
    contractFirstName: function (item) {
      return item.contract_name?.split(" - ")[0];
    },
    contractLastName: function (item) {
      return item.contract_name?.split(" - ")[1];
    },
  },
};
</script>
